import {Component, OnInit, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {Observable, combineLatest, first, map} from 'rxjs';
import {FeatureFlagService} from 'src/app/services/feature-flag.service';
import {CarouselComponent} from '../../carousel/carousel/carousel.component';
import {CarouselItemComponent} from '../../carousel/carousel-item/carousel-item.component';
import {ChartCardComponent} from '../chart-card/chart-card.component';
import {TurnoverKpiComponent} from '../turnover-kpi/turnover-kpi.component';
import {TurnoverChartComponent} from '../turnover-chart/turnover-chart.component';
import {TurnoverRiskChartComponent} from '../turnover-risk-chart/turnover-risk-chart.component';
import {TardinessKpiComponent} from '../tardiness-kpi/tardiness-kpi.component';
import {TardinessChartComponent} from '../tardiness-chart/tardiness-chart.component';
import {ShiftsCancelledKpiComponent} from '../shifts-cancelled-kpi/shifts-cancelled-kpi.component';
import {ShiftsCancelledChartComponent} from '../shifts-cancelled-chart/shifts-cancelled-chart.component';
import {PointsEarnedRedeemedKpiComponent} from '../points-earned-redeemed-kpi/points-earned-redeemed-kpi.component';
import {PointsEarnedRedeemedChartComponent} from '../points-earned-redeemed-chart/points-earned-redeemed-chart.component';
import {GoalCompletionRateKpiComponent} from '../goal-completion-rate-kpi/goal-completion-rate-kpi.component';
import {GoalCompletionRateChartComponent} from '../goal-completion-rate-chart/goal-completion-rate-chart.component';
import {ReferralsSubmittedKpiComponent} from '../referrals-submitted-kpi/referrals-submitted-kpi.component';
import {ReferralsSubmittedChartComponent} from '../referrals-submitted-chart/referrals-submitted-chart.component';

@Component({
  selector: 'app-caregiver-management-dashboard-chart-container',
  templateUrl:
    './caregiver-management-dashboard-chart-container.component.html',
  styleUrls: [
    './caregiver-management-dashboard-chart-container.component.scss',
  ],
  standalone: true,
  imports: [
    AsyncPipe,
    CarouselComponent,
    CarouselItemComponent,
    ChartCardComponent,
    TurnoverKpiComponent,
    TurnoverChartComponent,
    TurnoverRiskChartComponent,
    TardinessKpiComponent,
    TardinessChartComponent,
    ShiftsCancelledKpiComponent,
    ShiftsCancelledChartComponent,
    PointsEarnedRedeemedKpiComponent,
    PointsEarnedRedeemedChartComponent,
    GoalCompletionRateKpiComponent,
    GoalCompletionRateChartComponent,
    ReferralsSubmittedKpiComponent,
    ReferralsSubmittedChartComponent,
  ],
})
export class CaregiverManagementDashboardChartContainerComponent
  implements OnInit {
  private featureFlagService = inject(FeatureFlagService);

  enableAva$: Observable<boolean>;

  ngOnInit() {
    const teamEngageFlag$ = this.featureFlagService
      .get('tipc_enable_ava')
      .pipe(map((flagVarient) => flagVarient === 'on'));

    this.enableAva$ = combineLatest([teamEngageFlag$]).pipe(
      map(([teamEngageFlag]) => teamEngageFlag)
    );
  }
}
